import {createSelector} from 'reselect'

const getChooserState = state => state.licenses.chooser

export const getPrice = createSelector(
    getChooserState,
    chooserState => chooserState.price
)

export const getPricePerTimeInterval = createSelector(
    getChooserState,
    (chooserState) => chooserState.pricePerTimeInterval
)

export const getDiscount = createSelector(
    getChooserState,
    (chooserState) => chooserState.discount
)

export const getPurchasePeriod = createSelector(
    getChooserState,
    (chooserState) => chooserState.purchasePeriod
)

export const getStartDate = createSelector(
    getChooserState,
    (chooserState) => chooserState.startDate
)

export const getEndDate = createSelector(
    getChooserState,
    (chooserState) => chooserState.endDate
)

export const getUsersCount = createSelector(
    getChooserState,
    (chooserState) => chooserState.currentUsersCountSelected
)

export const isSelectUnlimitedUsers = createSelector(
    getChooserState,
    (chooserState) => chooserState.unlimited
)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/chooser/selectors.js